import React from 'react';
import { connect } from 'react-redux';
import { filterVisibleSections } from 'helpers';

import * as selectors from 'selectors';
import * as actions from 'actions';
import * as Modules from 'components/modules';

import styles from './works.css';

const sectionsMap = {
  text: Modules.TextSection,
  textMedia: Modules.TextMediaSection,
  textImage: Modules.TextMediaSection,
  textImageBackground: Modules.TextImageSection,
  flipper: Modules.FlipperSection,
  sliderDesktop: Modules.SliderDesktopSection,
  sliderMobile: Modules.SliderMobileSection,
  sliderFullscreen: Modules.SliderFullscreenSection,
  note: Modules.NoteSection,
  video: Modules.VideoSection,
};

class Works extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visibleSections: filterVisibleSections(props.caseItem, sectionsMap),
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pathname !== this.props.pathname && nextProps.caseItem) {
      this.setState({
        visibleSections: filterVisibleSections(nextProps.caseItem, sectionsMap),
      });
    }
  }

  render() {
    const {
      caseItem, nextPreview, page, pathname,
    } = this.props;
    const { visibleSections } = this.state;

    const metaSection =
      caseItem && caseItem.find(section => section && section.type === 'meta');
    return (
      <React.Fragment>
        <div className={styles.root} id="worksRoot">
          {caseItem && (
            <React.Fragment>
              <Modules.PreviewManager />
              <Modules.Meta {...metaSection} />
              {visibleSections.map((sectionItem, i) => {
                const Section = sectionsMap[sectionItem.type];
                return (
                  <Modules.VisibilitySensor
                    color={sectionItem.colors.logo}
                    id={`section-${i + 1}`}
                    key={`${pathname}${i + 1}`}
                    scrollIndex={i + 1}
                    code={sectionItem.code}
                  >
                    <div id={sectionItem.code}>
                      <Section {...sectionItem} scrollIndex={i + 1} />
                    </div>
                  </Modules.VisibilitySensor>
                );
              })}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({
  caseItem: selectors.getCase(state),
  nextPreview: selectors.getNextPreview(state),
  page: state.page,
  pathname: state.location.pathname,
});

export default connect(mapStateToProps)(Works);



// WEBPACK FOOTER //
// ./src/components/screens/Works/Works.js